import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../query-client';
import { IPagination } from '../IPagination';
import { fetchNominations } from './index';
import { IFetchPageQuery } from '../IFetchQueryOptions';
import { INomination } from './interface';

export const useNominationsListQuery = (query: IFetchPageQuery, options = {}) => {
    return useQuery<IPagination<INomination>, Error>({
        queryKey: [QueryKey.NOMINATIONS, query],
        queryFn: ({ signal }) => fetchNominations(query, signal),
        ...options,
    });
};
